module.exports = __webpack_public_path__ + "assets/img/p_item_3.80d60d92.png";